import { apiInstance } from 'api/utils';
import { ChargeType } from 'store/modules/AdvisorCharges/types';

const advisorChargesApi = {
  getAdvisorCharges: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/advisor-charges/?applied=1`
    });
  },
  updateCharge: ({
    portfolio,
    chargeId,
    charge
  }: {
    portfolio: string;
    chargeId: number;
    charge: ChargeType;
  }) => {
    return apiInstance({
      method: 'PUT',
      url: `/cases/${portfolio}/advisor-charges/${chargeId}/`,
      data: charge
    });
  },
  deleteCharge: ({
    portfolio,
    chargeId
  }: {
    portfolio: string;
    chargeId: number;
  }) => {
    return apiInstance({
      method: 'DELETE',
      url: `/cases/${portfolio}/advisor-charges/${chargeId}/`
    });
  },
  requestCharge: ({
    portfolio,
    policyId,
    charge
  }: {
    portfolio: string;
    policyId: number;
    charge: ChargeType;
  }) => {
    return apiInstance({
      method: 'POST',
      url: `/cases/${portfolio}/policies/${policyId}/add-advisor-charge/`,
      data: charge
    });
  }
};

export default {
  ...advisorChargesApi
};
